import React from 'react';

/** Empty container that simply displays it's children. */
export const EmptyWrapper: React.SFC = (props) => <React.Fragment>{props.children}</React.Fragment>;
